

function deepCopy(obj) {
  if (typeof obj !== 'object' || obj === null) {
    return obj;
  }

  let copy;

  if (Array.isArray(obj)) {
    copy = [];
    for (let i = 0; i < obj.length; i++) {
      copy[i] = deepCopy(obj[i]);
    }
  } else {
    copy = {};
    for (let key in obj) {
      if (obj.hasOwnProperty(key)) {
        copy[key] = deepCopy(obj[key]);
      }
    }
  }

  return copy;
}

export const columns = [
  {
    Header: 'KX ID',
    accessor: 'shippingId',
    Name: 'shippingId',
  },
  {
    Header: 'Entry Number',
    accessor: 'combinedEntryNumber',
    Name: 'combinedEntryNumber',
  },
  {
    Header: 'Importer',
    accessor: 'importerCode',
    Name: 'importerCode',
  },
  {
    Header: 'Job Status',
    accessor: 'reconShipmentStatus',
    Name: 'reconShipmentStatus',
  },
  {
    Header: 'Comments/Reference',
    accessor: 'comment',
    Name: 'comment',
  },
  {
    Header: 'Job Status Date & Time',
    accessor: 'statusUpdateTime',
    Name: 'statusUpdateTime',
  },
  {
    Header: 'CBP Status',
    accessor: 'reconCbpStatus',
    Name: 'reconCbpStatus',
  },
  {
    Header: 'CBP Status Date & Time',
    accessor: 'cpbStatusUpdateTime',
    Name: 'cpbStatusUpdateTime',
  },
  {
    Header: 'Reconciliation Type',
    accessor: 'reconciliationTypeCode',
    Name: 'reconciliationTypeCode',
  },
];

// Dummy Data


export const dummyData = [
  {
    shippingId: 'KX-007-REC1',
    entryNumber: '102030',
    importerName: 'BASF',
    comments: 'RECON SHIPMENT',
    reconShipmentStatus: 'COMPLETE',
    statusUpdateTime: '10/12/2022, 2:00:00 AM',
    cbpStatus: 'ACCEPTED',
    cbpStatusDate: '7/26/2022, 3:42:31 PM',
    reconType: 'VALUE-CHANGE',
  },
  {
    shipmentID: 'KX-007-REC2',
    entryNumber: '102040',
    importer: 'BASF',
    comments: 'RECON SHIPMENT',
    jobStatus: 'COMPLETE',
    jobStatusDate: '16/02/2023, 6:00:00 AM',
    cbpStatus: 'ACCEPTED',
    cbpStatusDate: '7/26/2022, 3:42:31 PM',
    reconType: 'VALUE-CHANGE',
  },
  {
    shipmentID: 'KX-007-REC2',
    entryNumber: '102040',
    importer: 'BASF',
    comments: 'RECON SHIPMENT',
    jobStatus: 'COMPLETE',
    jobStatusDate: '16/02/2023, 6:00:00 AM',
    cbpStatus: 'ACCEPTED',
    cbpStatusDate: '7/26/2022, 3:42:31 PM',
    reconType: 'VALUE-CHANGE',
  },
  {
    shipmentID: 'KX-007-REC2',
    entryNumber: '102040',
    importer: 'BASF',
    comments: 'RECON SHIPMENT',
    jobStatus: 'COMPLETE',
    jobStatusDate: '16/02/2023, 6:00:00 AM',
    cbpStatus: 'ACCEPTED',
    cbpStatusDate: '7/26/2022, 3:42:31 PM',
    reconType: 'VALUE-CHANGE',
  },
  {
    shipmentID: 'KX-007-REC2',
    entryNumber: '102040',
    importer: 'BASF',
    comments: 'RECON SHIPMENT',
    jobStatus: 'COMPLETE',
    jobStatusDate: '16/02/2023, 6:00:00 AM',
    cbpStatus: 'ACCEPTED',
    cbpStatusDate: '7/26/2022, 3:42:31 PM',
    reconType: 'VALUE-CHANGE',
  },
  {
    shipmentID: 'KX-007-REC2',
    entryNumber: '102040',
    importer: 'BASF',
    comments: 'RECON SHIPMENT',
    jobStatus: 'COMPLETE',
    jobStatusDate: '16/02/2023, 6:00:00 AM',
    cbpStatus: 'ACCEPTED',
    cbpStatusDate: '7/26/2022, 3:42:31 PM',
    reconType: 'VALUE-CHANGE',
  },
  {
    shipmentID: 'KX-007-REC2',
    entryNumber: '102040',
    importer: 'BASF',
    comments: 'RECON SHIPMENT',
    jobStatus: 'COMPLETE',
    jobStatusDate: '16/02/2023, 6:00:00 AM',
    cbpStatus: 'ACCEPTED',
    cbpStatusDate: '7/26/2022, 3:42:31 PM',
    reconType: 'VALUE-CHANGE',
  },
  {
    shipmentID: 'KX-007-REC2',
    entryNumber: '102040',
    importer: 'BASF',
    comments: 'RECON SHIPMENT',
    jobStatus: 'COMPLETE',
    jobStatusDate: '16/02/2023, 6:00:00 AM',
    cbpStatus: 'ACCEPTED',
    cbpStatusDate: '7/26/2022, 3:42:31 PM',
    reconType: 'VALUE-CHANGE',
  },
  {
    shipmentID: 'KX-007-REC2',
    entryNumber: '102040',
    importer: 'BASF',
    comments: 'RECON SHIPMENT',
    jobStatus: 'COMPLETE',
    jobStatusDate: '16/02/2023, 6:00:00 AM',
    cbpStatus: 'ACCEPTED',
    cbpStatusDate: '7/26/2022, 3:42:31 PM',
    reconType: 'VALUE-CHANGE',
  },
];

export function epochToDateTime(epochTime) {
  const dateObj = new Date(
    new Date(epochTime).toLocaleString('en-US', {
      timeZone: 'America/New_York',
    }),
  );
  const date = dateObj.toLocaleDateString();
  const time = dateObj.toLocaleTimeString();
  return `${date} ${time}`;
}

export function epochToDate(epochTime) {
  const date = new Date(epochTime);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Add leading zero if needed
  const day = String(date.getDate()).padStart(2, '0'); // Add leading zero if needed
  return `${year}-${month}-${day}`;
}

export const getImporterList = (data=[]) => {
  const importerList = data.map((item, index) => (
    {
      key: `${item.email}-${index}`,
      value: item.customerCode,
      text: item.companyName,
      disabled: (!item.customerCode || !item.companyName) ? true : false
    }
  ))
  return importerList;
}

export const transformResponse = (payload) => {
  let newResopnse = deepCopy(payload)
  newResopnse.map((item, index) => {
      item.combinedEntryNumber = (item.filerCode || item.entryNumber) ? item.filerCode + item.entryNumber : "";
      item.statusUpdateTime = item.statusUpdateTime ? epochToDateTime(item.statusUpdateTime) : "";
      item.cpbStatusUpdateTime = item.statusUpdateTime;
      if(!("reconCbpStatus" in item)){
        item.reconCbpStatus = "NONE";
      }
      if(item.reconciliationTypeCode === "NA1"){
          item.reconciliationTypeCode = "No Change"
      }
      else if(item.reconciliationTypeCode === "CE1")
          item.reconciliationTypeCode = "Change"
  })
  return newResopnse
}

export function dateToEpoch(date) {
  try {
    const dt = new Date(date);
    const epoch = Math.floor(dt.getTime() / 1000);
    return epoch;
  } catch (error) {
    return null;
  }
}
